<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<div class="card-header">
					<el-form :inline="true" :model="searchForm" class="demo-form-inline" ref="searchform">
						<el-form-item :label="$t('model.name')">
							<el-input v-model="searchForm.name" :placeholder="$t('model.name')"></el-input>
						</el-form-item>
						<el-form-item>
							<el-button type="primary" @click="search">{{ $t('device.inquire') }}</el-button>
							<el-button @click="reset">{{ $t('device.reset') }}</el-button>
						</el-form-item>
					</el-form>
					<el-button type="primary" @click="handleEdit">{{ $t('goods.add') }}</el-button>
				</div>
			</template>

			<el-table :data="tableData" border stripe>
				<el-table-column prop="id" label="ID" width="80"></el-table-column>
				<el-table-column prop="name" :label="$t('model.name')"></el-table-column>
				<el-table-column prop="protocol_id" :label="$t('protocol.id')"></el-table-column>
				<el-table-column prop="protocol_name" :label="$t('protocol.name')"></el-table-column>
				<el-table-column prop="description" :label="$t('model.description')"></el-table-column>
				<el-table-column prop="is_same_btach" label="单批量参数复用" width="140" align="center">
					<template #default="{row}">{{ row.is_same_btach == 1 ? '是' : '否' }}</template>
				</el-table-column>
				<el-table-column prop="sort_num" label="排序值" width="100" align="center"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="200">
					<template #default="{row}">
						<el-button size="small" @click="handleEdit(row)">{{ $t('device.edit') }}</el-button>
						<el-button size="small" type="danger" @click="handleDelete(row)">{{ $t('goods.delete') }}</el-button>
					</template>
				</el-table-column>
			</el-table>

			<el-dialog :title="editTitle" v-model="dialogVisible" width="40%">
				<el-form :model="editForm" label-width="120px">
					<el-form-item :label="$t('model.name')">
						<el-input v-model="editForm.name"></el-input>
					</el-form-item>
					<el-form-item :label="$t('protocol.name')">
						<el-select v-model="editForm.protocol_id" :placeholder="$t('model.select_protocol')">
							<el-option v-for="item in protocolList" :key="item.id" :label="item.name"
								:value="item.id"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="$t('model.description')">
						<el-input v-model="editForm.description" type="textarea"></el-input>
					</el-form-item>
					<el-form-item label="单批量参数复用">
						<el-radio-group v-model="editForm.is_same_btach">
							<el-radio :label="1">是</el-radio>
							<el-radio :label="0">否</el-radio>
						</el-radio-group>
					</el-form-item>
					<el-form-item label="排序值">
						<el-input-number v-model="editForm.sort_num" :min="0" controls-position="right"
							style="width:160px"></el-input-number>
					</el-form-item>
				</el-form>
				<template #footer>
					<el-button @click="dialogVisible = false">{{ $t('device.cancel') }}</el-button>
					<el-button type="primary" @click="submitForm">{{ $t('device.confirm') }}</el-button>
				</template>
			</el-dialog>

			<el-pagination @current-change="handleCurrentChange" @size-change="handleSizeChange"
				:page-sizes="[10, 20, 50, 100]" :page-size="searchForm.size" layout="total, sizes, prev, pager, next"
				:total="total"></el-pagination>
		</el-card>
	</div>
</template>

<script>
	import deviceModel from '@/model/deviceModel'
	import deviceProtocol from '@/model/deviceProtocol'

	export default {
		data() {
			return {
				searchForm: {
					name: '',
					page: 1,
					size: 20
				},
				tableData: [],
				total: 0,
				protocolList: [],
				dialogVisible: false,
				editForm: {
					id: '',
					name: '',
					protocol_id: '',
					description: '',
					is_same_btach: 0,
					sort_num: 0
				}
			}
		},
		computed: {
			editTitle() {
				return this.editForm.id ? this.$t('device.edit') : this.$t('goods.add')
			}
		},
		async mounted() {
			await this.getProtocolList()
			this.search()
		},
		methods: {
			async getProtocolList() {
				const res = await deviceProtocol.selectList({ size: 10000 })
				if (res.code === 200) {
					this.protocolList = res.data.list
				}
			},
			async search() {
				const res = await deviceModel.lists(this.searchForm)
				if (res.code === 200) {
					this.tableData = res.data.list
					this.total = res.data.total
				}
			},
			reset() {
				this.searchForm.name = ''
				this.searchForm.page = 1
				this.search()
			},
			handleEdit(row) {
				this.editForm = row.id ? {
					...row
				} : {
					id: '',
					name: '',
					protocol_id: '',
					description: '',
					is_same_btach: 0,
					sort_num: 0
				}
				this.dialogVisible = true
			},
			handleDelete(row) {
				this.$confirm(this.$t('goods.confirm_delete'), this.$t('goods.tip'), {
					type: 'warning'
				}).then(async () => {
					const res = await deviceModel.delete({ id: row.id })
					if (res.code === 200) {
						this.search()
					}
				})
			},
			async submitForm() {
				const res = await deviceModel.operate(this.editForm)
				if (res.code === 200) {
					this.dialogVisible = false
					this.search()
				}
			},
			handleCurrentChange(page) {
				this.searchForm.page = page
				this.search()
			},
			handleSizeChange(size) {
				this.searchForm.size = size
				this.searchForm.page = 1
				this.search()
			}
		}
	}
</script>
